
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'organizers-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('organizersListing'), [
          translate('auctions'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_ORGANIZERS_STORE);
      });

      await store.dispatch(Actions.GET_ORGANIZERS);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('organizerInfo'),
          key: 'titleEn',
        },
        {
          name: translate('organizerNameAr'),
          key: 'titleAr',
        },
        {
          name: translate('activeStatus'),
          key: 'is_active',
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusOrganizer = async (organizer) => {
        const deletedMessage = organizer.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_ORGANIZER, organizer.id);
          await store.dispatch(Actions.GET_ORGANIZERS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const successMsg = organizer.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const editOrganizer = (id) => {
        router.push({ name: 'organizers-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_ORGANIZER_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_ORGANIZERS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.organizersList),
        tableHeader,
        toggleStatusOrganizer,
        translate,
        totalItems: computed(() => store.getters.organizersListCount),
        pageChanged,
        goTo,
        editOrganizer,
        loading,
        can,
      };
    },
  });
